import { useEffect } from "react";

const GoogleAnalytics = () => {
	useEffect(() => {
		// Cria o script do gtag
		const script1 = document.createElement("script");
		script1.async = true;
		script1.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_ID}`;

		// Cria o script de configuração
		const script2 = document.createElement("script");
		script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.REACT_APP_GA_ID}');
        `;
		// Adiciona os scripts ao documento
		document.head.appendChild(script1);
		document.head.appendChild(script2);

		// Cleanup quando o componente for desmontado
		return () => {
			document.head.removeChild(script1);
			document.head.removeChild(script2);
		};
	}, []);

	return null;
};

export default GoogleAnalytics;
